import React from 'react';

import BrowseEntitiesSkeleton from 'components/data-containers/BrowseEntities/SkeletonLoader';
import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';

import { EntityContext } from 'context/entityContext';

const BrowseRelated = React.lazy(
  () => import('components/data-containers/BrowseEntities/BrowseRelated') as any
);

const View: React.FC<any> = ({ setSelectedSalesType }: any): any => {
  const ctx = React.useContext(EntityContext);
  const isCompare = Boolean(ctx.compareMode);

  if (isCompare) {
    return (
      <Layout.MaxWidth>
        <Message>Overview cards do not support compare mode.</Message>
      </Layout.MaxWidth>
    );
  }

  return (
    <div>
      <React.Suspense
        fallback={
          <BrowseEntitiesSkeleton
            title="View Related"
            browseEntityType="artist"
            showToggle
            enableSearch
            browseRelated
            isBrowseTable
          />
        }
      >
        <BrowseRelated
          {...ctx}
          id="view-related"
          entityTitle="Artist"
          setSelectedSalesType={setSelectedSalesType}
          genericTitle="View Related"
        />
      </React.Suspense>
    </div>
  );
};

export default View;
